import data from "../../../../../packages/react/src/Select/Select.docs.json";
import { Select, Text } from '@primer/react';
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  Select,
  Text,
  DeprecationBanner,
  React
};